import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-submit-button-group',
  templateUrl: './submit-button-group.component.html',
})
export class SubmitButtonGroupComponent implements OnInit {
  @Output() submitEvent = new EventEmitter<any>();
  @Output() cancelEvent = new EventEmitter<any>();
  @Input() disabled = false;
  @Input() submitButtonText = 'submit';

  constructor() {}

  ngOnInit(): void {}
}
